import Request from '../../utilities/Request';

export function uploadDocument(file, name) {
  return Request.post(
    `/api/data/v1/data-files?public=false&name=${name}`,
    file
  );
}

export function getDocumentDetails(id) {
  return Request.get(`/api/data/v1/data-files/${id}/details`);
}
